export default "__VITE_ASSET__2$GdzQ8y__"